import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import {Check} from "lucide-react";
import {cn} from "./utils";
import "./Checkbox.module.css";

const Checkbox = React.forwardRef(({className, ...props}, ref) => {
    return (
        <CheckboxPrimitive.Root ref={ref} data-slot="checkbox" className={cn("ui-checkbox", className)} {...props}>
            <CheckboxPrimitive.Indicator data-slot="checkbox-indicator" className={"ui-checkbox-indicator"}>
                <Check size={12} />
            </CheckboxPrimitive.Indicator>
        </CheckboxPrimitive.Root>
    );
});

Checkbox.displayName = "Checkbox";

export {Checkbox};
